var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._v(" 欢迎来到 胖球的跑步实验室"),_c('br'),_vm._v("这里有我开发的一些工具，以及我对跑步的分享和思考"),_c('br'),_vm._v("希望对你有用! ")])
}]

export { render, staticRenderFns }